

export default function scrollToHash(form) {

    document.querySelectorAll('.scroll-to-hash').forEach(anchor => {

        const toElement = document.querySelector(anchor.getAttribute('href'))

        if (toElement) {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                $('.navbar-collapse').collapse('hide');
                if($('body').hasClass('menu-open')){
                    $('body').removeClass('menu-open')
                }
                
                toElement.scrollIntoView({
                    behavior: 'smooth'
                });
            });
        } else {
            anchor.addEventListener('click', function (e) {
                e.preventDefault()
            })
        }
    });
}